import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import MotiveTitle from '../MotiveTitle';
import AssembleColorIcon from '../../../../../../../common/icons/icr_armado.svg';
import AssembleProduct from '../../../forms/assembleProduct/AssembleProduct';

const AssembleProductMobile = ({ ...props }) => {
  const { motiveId, product, profile, type, onData } = props;

  return (
    <Box>
      <MotiveTitle
        icon={AssembleColorIcon}
        title="Armar producto"
        subtitle="Agenda tu armado"
        mobile
      />
      <AssembleProduct
        mobile
        motiveId={motiveId}
        product={product}
        profile={profile}
        type={type}
        onData={onData}
      />
    </Box>
  );
};

AssembleProductMobile.propTypes = {
  motiveId: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  type: PropTypes.string,
  onData: PropTypes.func,
};

export default AssembleProductMobile;
